import { render, staticRenderFns } from "./GoodsEvaluate.vue?vue&type=template&id=91cd0920&scoped=true"
import script from "./GoodsEvaluate.vue?vue&type=script&lang=js"
export * from "./GoodsEvaluate.vue?vue&type=script&lang=js"
import style0 from "./GoodsEvaluate.vue?vue&type=style&index=0&id=91cd0920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cd0920",
  null
  
)

export default component.exports